import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '@app/core/services/auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(
        private router: Router,
        private authService: AuthService,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.authService.isUserAuthenticated().pipe(
            switchMap((response) => of(true)),
            catchError((error) => {
                return of(this.router.parseUrl('/login'));
            }),
        );
    }
}
